import React, { useContext, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import useMedia from '../../hooks/useMedia';

import { Actions, Categories, Labels } from '../../types/gtm';
import { DeleteAccountContext } from '.';
import Button from '../../components/Button';
import Title from '../../components/Title';
import { ListMobileTopics } from './components/ListMobileTopics';
import DeleteParentalDetails from './DeleteParentalDetails';
import DeleteSubscriptionsDetails from './DeleteSubscriptionsDetails';
import DeleteGloboAdsDetails from './DeleteGloboAdsDetails';

import { DeleteDescription, DivProducts, List } from './styles';

const DeleteSubscriptions = () => {
  const { subscriptionData, setStep } = useContext(DeleteAccountContext);
  const { user } = useAuth();
  const mobile = useMedia('(max-width: 650px)');

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.DeleteAccount,
      event_action: Actions.Pageview,
      event_label: Labels.DeleteAccountPageInfo,
      bd_suser_code: user?.globoId,
    });
  }, [user]);

  const continuar = () => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.DeleteAccount,
      event_action: Actions.ClickProceed,
      event_label: Labels.DeleteAccountPageInfo,
      bd_suser_code: user?.globoId,
    });

    setStep('reason');
  };

  return (
    <>
      <Title variant="page">Exclusão de conta</Title>
      <DeleteDescription>
        <p>
          A Conta Globo é o principal cadastro que centraliza suas assinaturas e
          serviços gratuitos na Globo.
        </p>
        <p>
          Ao solicitar a exclusão da sua conta, iniciamos o processo de remoção
          de todos os dados vinculados a ela. Com isso, você perde o acesso aos
          benefícios associados à conta excluída.
        </p>
        <p>
          A exclusão afeta apenas a Conta Globo solicitada. Caso você possua
          outras Contas Globo, elas permanecerão inalteradas.
        </p>
        <strong>Importante:</strong>
        <List>
          <li>
            <p>
              Se você faz parte de uma Família Globo que compartilha os
              benefícios de uma assinatura, será removido automaticamente.
            </p>
          </li>
          <li>
            <p>
              Todos os serviços gratuitos vinculados à conta também serão
              cancelados.
            </p>
          </li>
        </List>
      </DeleteDescription>

      {(subscriptionData.signatures.length > 0 ||
        subscriptionData.responsibleForUnderages.length > 0) && (
        <Title variant="base">
          Antes de prosseguir, é necessário verificar as pendências da sua conta
          e resolvê-las:
        </Title>
      )}

      {mobile ? (
        <>
          <ListMobileTopics
            signatures={subscriptionData.signatures}
            responsibleForUnderages={subscriptionData.responsibleForUnderages}
            isUserB2BAccount={subscriptionData.isUserB2BAccount}
            globoId={user.globoId}
          />
        </>
      ) : (
        <>
          {subscriptionData.signatures.length > 0 && (
            <DeleteSubscriptionsDetails />
          )}
          {subscriptionData.responsibleForUnderages.length > 0 && (
            <DeleteParentalDetails />
          )}
          {subscriptionData.isUserB2BAccount === true && (
            <DeleteGloboAdsDetails />
          )}
        </>
      )}

      {subscriptionData.signatures.length === 0 &&
        subscriptionData.responsibleForUnderages.length === 0 &&
        subscriptionData.isUserDeletionAllowedByAllSubscriptions &&
        subscriptionData.isUserB2BAccount === false && (
          <>
            <DivProducts>
              <div className="divButton">
                <Button
                  width="368px"
                  variant="primary"
                  type="button"
                  onClick={() => continuar()}
                >
                  Excluir Conta Globo
                </Button>
              </div>
            </DivProducts>
          </>
        )}
    </>
  );
};

export default DeleteSubscriptions;
